export default {
  "get|report/gettags": (option) => {
    return {
      code: 200,
      msg: "操作成功",
      data: [
        {
          text: "事業のヒント",
          tcode: "t1",
          children: [
            {
              text: "国内経済",
              tcode: "1",
            },
            {
              text: "世界経済",
              tcode: "2",
            },
            {
              text: "金利",
              tcode: "3",
            },
            {
              text: "為替",
              tcode: "4",
            },
            {
              text: "コモディティ",
              tcode: "5",
            },
            {
              text: "海外情勢",
              tcode: "6",
            },
            {
              text: "国内経済2",
              tcode: "7",
            },
            {
              text: "世界経済2",
              tcode: "8",
            },
            {
              text: "金利2",
              tcode: "9",
            },
            {
              text: "為替2",
              tcode: "10",
            },
            {
              text: "コモディティ2",
              tcode: "11",
            },
            {
              text: "海外情勢2",
              tcode: "12",
            },
          ],
        },
        {
          text: "経済",
          tcode: "t2",
          children: [
            {
              text: "収益性向上",
              tcode: "1",
            },
            {
              text: "人材の強化（採用・育成・多様化への対応）",
              tcode: "2",
            },
            {
              text: "売り上げ・シェア拡大",
              tcode: "3",
            },
            {
              text: "事業基盤の強化・再編、事業ポートフォリオの再構築",
              tcode: "4",
            },
            {
              text: "新製品・新サービス・新事業の開発",
              tcode: "t5",
            },
            {
              text: "デジタル技術の活用・戦略的投資",
              tcode: "6",
            },
          ],
        },
        {
          text: "業界",
          tcode: "t3",
          children: [
            {
              text: "農業・畜産・水産・食料品・飲料分野",
              tcode: "1",
            },
          ],
        },
      ],
    };
  },
  "get|report/gettagfirst": (option) => {
    return {
      code: 200,
      msg: "操作成功",
      data: [
        {
          itemid: "1",
          text: "事業のヒント",
          tcode: "t1",
          children: [],
        },
        {
          itemid: "2",
          text: "経済",
          tcode: "t2",
          children: [],
        },
        {
          itemid: "3",
          text: "業界",
          tcode: "t3",
          children: [],
        },
      ],
    };
  },
  "get|library/gettagfirst": (option) => {
    return {
      code: 200,
      msg: "操作成功",
      data: [
        {
          itemid: "1",
          text: "事例集",
          tcode: "t1",
          children: [],
        },
        {
          itemid: "2",
          text: "トレンド解説",
          tcode: "t2",
          children: [],
        },
        {
          itemid: "3",
          text: "税務・事業承継",
          tcode: "t3",
          children: [],
        },
        {
          itemid: "4",
          text: "IPO",
          tcode: "t4",
          children: [],
        },
        {
          itemid: "5",
          text: "M&A",
          tcode: "t5",
          children: [],
        },
        {
          itemid: "6",
          text: "財務分析のヒント",
          tcode: "t6",
          children: [],
        },
        {
          itemid: "7",
          text: "業界レポート",
          tcode: "t7",
          children: [],
        },
      ],
    };
  },
  "get|library/GetTagForLibrary": (option) => {
    return {
      code: 200,
      msg: "操作成功",
      data: [
        {
          itemid: "1",
          text: "ビジネスマッチング事例集",
          tcode: "t1",
          children: [],
        },
        {
          itemid: "2",
          text: "ビジネス事例集",
          tcode: "t2",
          children: [],
        },
      ],
    };
  },
  "get|library/GetLibrarySearchTag": (option) => {
    return {
      code: 200,
      msg: "操作成功",
      data: [
        {
          text: "事業のヒント",
          tcode: "t1",
          children: [
            {
              text: "国内経済",
              tcode: "1",
            },
            {
              text: "世界経済",
              tcode: "2",
            },
            {
              text: "金利",
              tcode: "3",
            },
            {
              text: "為替",
              tcode: "4",
            },
            {
              text: "コモディティ",
              tcode: "5",
            },
            {
              text: "海外情勢",
              tcode: "6",
            },
            {
              text: "国内経済2",
              tcode: "7",
            },
            {
              text: "世界経済2",
              tcode: "8",
            },
            {
              text: "金利2",
              tcode: "9",
            },
            {
              text: "為替2",
              tcode: "10",
            },
            {
              text: "コモディティ2",
              tcode: "11",
            },
            {
              text: "海外情勢2",
              tcode: "12",
            },
          ],
        },
        {
          text: "経済",
          tcode: "t2",
          children: [
            {
              text: "収益性向上",
              tcode: "1",
            },
            {
              text: "人材の強化（採用・育成・多様化への対応）",
              tcode: "2",
            },
            {
              text: "売り上げ・シェア拡大",
              tcode: "3",
            },
            {
              text: "事業基盤の強化・再編、事業ポートフォリオの再構築",
              tcode: "4",
            },
            {
              text: "新製品・新サービス・新事業の開発",
              tcode: "5",
            },
            {
              text: "デジタル技術の活用・戦略的投資",
              tcode: "6",
            },
          ],
        },
        {
          text: "業界",
          tcode: "t3",
          children: [
            {
              text: "農業・畜産・水産・食料品・飲料分野",
              tcode: "1",
            },
          ],
        },
        {
          text: "マクロ経済メモ",
          tcode: "t4",
          children: [
            {
              text: "",
              tcode: "1",
            },
          ],
        },
      ],
    };
  },
};
